/**
 * Gmail Support manage-screen copy. Spread into enIntegrations so that file
 * stays under the 500-line ceiling.
 */
export const enGmail = {
  'gmailSettings.title': 'Gmail',
  'gmailSettings.subtitle': 'Receive support emails from your connected Gmail inbox',
  'gmailSettings.emailLabel': 'Email: {email}',
  'gmailSettings.needsReconnect': 'Reconnect required',
  'integrations.toast.gmailDenied':
    'Gmail access was not granted. Click Connect and approve the Google prompt.',
  'integrations.toast.gmailInvalidState':
    'Gmail sign-in expired. Click Connect and finish the Google prompt in one go.',
  'integrations.toast.gmailBadCredentials':
    'Gmail could not connect: the OAuth client secret does not match GMAIL_CLIENT_ID. Paste the Client secret from that Google Cloud OAuth client, restart the API, and Connect again.',
  'integrations.toast.gmailRedirectMismatch':
    'Gmail could not connect: GMAIL_OAUTH_REDIRECT_URI must match the Authorized redirect URI in Google Cloud Console.',
  'integrations.toast.gmailProfileFailed':
    'Gmail authorized, but we could not read your Google account email. Click Connect and allow email access, then try again.',
  'integrations.toast.gmailExpiredCode':
    'Gmail sign-in expired. Click Connect and finish the Google prompt in one go.',
} as const;
